import { connect } from 'react-redux';
import RiskRow from './RiskRow';
import { sortRiskRequest, updateRiskFlag } from '../../../../../store/actions/risks.actions';

const mapDispatchToProps = { sortRiskRequest, updateFlag: updateRiskFlag };

export default connect(null, mapDispatchToProps)(RiskRow);